import(/* webpackMode: "eager" */ "/home/coder/pubky-runtime/app-classic/src/app/global-error.tsx");
